
<wiz-group  width="100%" height="100%" class="section-container">
    <wiz-vgroup padding="10px" width="100%" height="100%" >
       <wiz-vgroup #vgAddValidator wizValidationContainer width="100%" height="100%" >
        
        <wiz-label class="smallTitleLabel" [wizLabel]="'$.scen.values.title.$'"></wiz-label>
        <wiz-vgroup width="100%" [visible]="hasParent">
            <wiz-label wizLabel="$.common.parent.code.$" class="sameAsLabel"></wiz-label>
            <wiz-hgroup width="100%" verticalAlign="center"><!-- libellé du scenar -->
                <span
                #blockBack
                [style.backgroundColor]="parentColor"
                width="10px"
                height="10px"
                class="scen-round-mark" 
                ></span>
                <wiz-label
                [wizLabel]="parentLabel"
                [wizTextBehavior]="'truncate'"
                [wizTooltip]="parentLabel"
                ></wiz-label>
            </wiz-hgroup>   
        </wiz-vgroup>
        
        <wiz-hgroup width="100%" wizValidationContainer>
        <wiz-text-input #tiCode 
            [wizLabel]="'$.common.code.$'"
            class="upper-case-input"  
            [wizFocusMode]="'PASS'"
            [wizShowErrors]="true"
            [wizMandatory]="true"
            [wizValidator]="uniqueCodeValidator()"
            width="100%"></wiz-text-input>

            <wiz-vgroup width="100px">
            <wiz-label wizLabel="$.scen.color.$" style="font-size: 11px"></wiz-label>
            <wiz-hgroup verticalAlign="center">
                <span
                #blockBack
                [style.backgroundColor]="backgroundColor"
                width="20px"
                height="20px"
                (click)="showColorPicker($event)"
                style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
                ></span>
                <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
            </wiz-hgroup>
            </wiz-vgroup>


        </wiz-hgroup>

        <wiz-translation-basic
        #trsLabel
        wizValidator
        [wizLabel]="'$.common.label.$'"
        width="100%"
        [wizShowErrors]="true"
        [wizMandatory]="true"
        ></wiz-translation-basic>

        <wiz-translation-basic
        #trsDesc
        [wizTranslationMode]="'textarea'"
        [wizLabel]="'$.common.description.$'"
        width="100%"
        height="100px"
        >
        </wiz-translation-basic>

       </wiz-vgroup>
       <wiz-hgroup padding="3px" horizontalAlign="end" width="100%">
            <wiz-button #btnSave  [wizLabel]="'$.common.save.$'" [wizDisabled]="disableSave"
            (wizClick)="save()"
            [wizIcon]="'arrow-right'" [iconPlacement]="'right'" width="240px"></wiz-button>
            <wiz-button
            #btnCancel
            class="cancel-button"
            (wizClick)="hide()"
            [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'"></wiz-button>
        </wiz-hgroup>

    </wiz-vgroup>

  <!-- overlay de fermeture en haut à droite -->  
  <wiz-hgroup padding="10px" width="100%" horizontalAlign="end">
    <wiz-icon (click)="hide()" style="cursor: pointer">close</wiz-icon>
  </wiz-hgroup>
  

</wiz-group>
